import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { URL_GLOBAL } from 'src/environments/environment';
import { AuthService } from '../vos/auth.service';


@Injectable({
  providedIn: 'root'
})
export class PackageService {

  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) { }

  getAllPackages() {
    return this.http.get<Array<any>>(`${URL_GLOBAL}/web/packages`, { headers: this.authService.userToken() });
  }

  getPackagesWithFilter(params?: any) {
    return this.http.get<Array<any>>(`${URL_GLOBAL}/web/packages-filter?description=${params.description ? params.description : ''}&code=${params.code ? params.code : ''}&clientId=${params.clientId ? params.clientId : ''}`, { headers: this.authService.userToken() });
  }

  savePackage(data: any): Observable<any> {
    return this.http.post<any>(`${URL_GLOBAL}/web/package`, data, { headers: this.authService.userToken() });
  }
  find(id: any): Observable<any> {
    return this.http.get(`${URL_GLOBAL}/web/package/${id}`, { headers: this.authService.userToken() });
  }

  update(id: any, data: any): Observable<any> {
    return this.http.put<any>(`${`${URL_GLOBAL}/web/package`}/${id}`, data, { headers: this.authService.userToken() });
  }

  destroy(id: any): Observable<any> {
    return this.http.delete<any>(`${`${URL_GLOBAL}/web/package`}/${id}`, { headers: this.authService.userToken() });
  }

  deletePackage(id: any): Observable<any> {
    return this.http.delete<any>(`${`${URL_GLOBAL}/web/delete-package`}/${id}`, { headers: this.authService.userToken() });
  }

  excluirItemPacoteServico(id): Observable<any> {
    return this.http.delete<any>(`${URL_GLOBAL}/web/packages/excluir/servico/${id}`, { headers: this.authService.userToken() });
  }
  excluirItemPacoteProduto(id): Observable<any> {
    return this.http.delete<any>(`${URL_GLOBAL}/web/packages/excluir/produto/${id}`, { headers: this.authService.userToken() });
  }
  deleteProductPackageBudget(id): Observable<any> {
    return this.http.post<any>(`${URL_GLOBAL}/web/package/delete-product-package-budget`, id, { headers: this.authService.userToken() });
  }
  deleteServicePackageBudget(id): Observable<any> {
    return this.http.post<any>(`${URL_GLOBAL}/web/package/delete-service-package-budget`, id, { headers: this.authService.userToken() });
  }
  filterPackages(parametros) {
    return this.http.get(`${URL_GLOBAL}/web/packages/filterPackages?nome=${parametros}`, { headers: this.authService.userToken() });
  }
  getBudgetsByPackage(package_id) {
    return this.http.get(`${URL_GLOBAL}/web/budget-with-package?package_id=${package_id}`, { headers: this.authService.userToken() });
  }
}
